/** User-facing strings: settings. */
export const settings = {
    title: "Settings",
    description: "Your profile, how the dashboard looks, and your API token.",
    profile: {
        title: "Profile",
        name: "Name",
        email: "Email",
        notSet: "Not set",
        note: "Your name, email and password belong to your sign-in account. ",
        manage: "Manage your account",
    },
    appearance: {
        title: "Appearance",
        theme: "Theme",
        system: "System",
        light: "Light",
        dark: "Dark",
        hint: "System follows your device. The header button switches it too.",
    },
    token: {
        title: "API token",
        text: "The token your agents enrol with: reveal, copy or rotate it, and see when it was last rotated.",
        history: "Token and rotation history",
        apiReference: "API reference",
    },
    notifications: {
        title: "Notifications",
        viewAll: "View all notifications",
    },
};
